import React from 'react';
import useFormattingSettings from '../../hooks/useFormattingSettings';

const FormattedDate = ({ 
  value, 
  format = null, // Permite override do formato padrão
  style = {}, 
  className = ""
}) => {
  const { formatDate } = useFormattingSettings();
  
  if (!value) {
    return <span className={className} style={style}>-</span>;
  }
  
  const formattedDate = formatDate(value, format);
    
  return (
    <span className={className} style={style}>
      {formattedDate}
    </span>
  );
};

export default FormattedDate;